<template>
  <ItemPage
    :title="title"
    size="md"
    :actions="actions"
  >
    <template
      v-if="educationStageView"
    >
      <v-simple-table fixed-header>
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <div
          v-else
        >
          <v-data-table
            :headers="headers"
            :items="contents"
            :items-per-page="10"
            item-key="id"
          >
            <template #item.name="{ item }">
              <router-link :to="{ name: 'reinos.EducationSystem.educationSystemID.EducationStage.educationStageID.Grade', params: { educationStageID: item.id } }">
                {{ item.name }}
              </router-link>
            </template>
            <template #item.status="{ item }">
              {{ item.status ? 'Ativo' : 'Inativo' }}
            </template>
            <template #item.created_at="{ item }">
              <v-btn
                class="mx-2"
                outlined
                small
                fab
                color="primary"
                @click="openFormEditItemDialog(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                outlined
                small
                fab
                color="primary"
                @click="confirmDelete(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-simple-table>
    </template>
    <template v-else>
      seu usuário não tem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import FormAddNewItemDialog from '@/components/settings/FormAddNewItemDialog.vue'
import FormEditItemDialogWithShortName from '@/components/settings/FormEditItemDialogWithShortName.vue'

import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
    Load,
    ItemPage
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      title: 'Segmentos',
      educationSystem: null,
      educationStageView: false,
      loading: false,
      loadingMsg: '',
      contents: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Abreviatura',
          align: 'start',
          value: 'short_name'
        },
        {
          text: 'Slug',
          align: 'start',
          value: 'slug'
        },
        {
          text: 'Ordem',
          align: 'start',
          value: 'order'
        },
        {
          text: 'Status',
          align: 'start',
          value: 'status'
        },
        {
          text: 'Ações',
          align: 'start',
          value: 'created_at'
        }
      ]
    }
  },

  computed: {
    actions () {
      return [
        {
          label: 'Adicionar Segmento',
          action: this.openFormAddNewitemDIalog,
          icon: 'mdi-plus',
          disabled: !this.educationStageView
        }
      ]
    },

    educationSystemID () {
      return this.$route.params.educationSystemID
    }
  },
  async mounted () {
    await this.fetchAll()
  },
  methods: {
    async fetchAll () {
      // this.educationStageView = utils.checkPermissions('intranet-users.view-any')
      this.educationStageView = true
      try {
        this.educationSystem = await this.$api.getEducationSystem(this.educationSystemID)
        this.title = this.educationSystem.short_name
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter o sistema de ensino, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
      await this.listEducationStages()
    },
    async listEducationStages () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        this.contents = await this.$api.listEducationStages(this.educationSystemID)
      } catch (e) {
        this.getErrors(e)
      }
      this.loading = false
    },
    openFormAddNewitemDIalog () {
      this.$dialog.custom(FormAddNewItemDialog).with({ title: 'Segmento', action: this.newEducationStage }).show()
        .then((educationStage) => {
          if (!educationStage) {
            return false
          }
          this.listEducationStages()
        })
    },
    openFormEditItemDialog (educationStage) {
      this.$dialog.custom(FormEditItemDialogWithShortName).with({ title: 'Segmento', item: educationStage, action: this.updateEducationStage }).show()
        .then((updatedEducationStage) => {
          if (!updatedEducationStage) {
            return false
          }
          this.listEducationStages()
        })
    },
    async newEducationStage (data) {
      await this.$api.newEducationStage(this.educationSystemID, data)
    },
    async updateEducationStage (id, data) {
      await this.$api.updateEducationStage(id, data)
    },
    async confirmDelete (item) {
      this.$dialog.confirm(`Apagar ${item.name}?`)
        .text('Tem certeza que deseja apagar? não será possível reverter')
        .label('Apagar')
        .onConfirm(async () => {
          await this.deleteEducationStage(item.id)
        })
        .show()
    },
    async deleteEducationStage (id) {
      try {
        await this.$api.deleteEducationStage(id)
        this.$store.dispatch('setSnackBar', { text: 'Segmento apagado com sucesso.' })
        this.listEducationStages()
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível apagar o Segmento, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
